const data = [
  { id: 1, link: "", title: "Home" },
  { id: 2, link: "about", title: "About" },
  { id: 3, link: "projects", title: "Projects" },
  { id: 4, link: "skills", title: "Skills" },
  { id: 5, link: "contacts", title: "Contacts" },
];

export default data;
